module.exports = __webpack_public_path__ + "img/468.7ead50cd.jpg";